import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import * as RadixRadioGroup from '@radix-ui/react-radio-group';
import * as RadixLabel from '@radix-ui/react-label';

// Utils
import bemify from 'utils/bemify';

// Styles
import stylesModule from './styles.module.scss';


const styles = bemify(stylesModule);

const RadioGroup = forwardRef(({
  className = null,
  disabled = false,
  items = null,
  onChange = () => {},
  value = null
}, ref) => {
  if (!Array.isArray(items) || !items.length) return null;

  return (
    <RadixRadioGroup.Root
      ref={ref}
      className={`${styles.radioGroup}${
        disabled ? ` ${styles.radioGroup_disabled}` : ''}${
        className ? ` ${className}` : ''}`}
      defaultValue={value || items[0].value}
      disabled={disabled}
      value={value}
      onValueChange={onChange}
    >
      {items.map((entry, index) => (
        <div
          key={index}
          className={styles.radioGroup__itemWrapper}
        >
          <RadixRadioGroup.Item
            className={styles.radioGroup__input}
            id={`radio-group-${index}`}
            value={entry.value}
          >
            <RadixRadioGroup.Indicator className={styles.radioGroup__itemIndicator} />
          </RadixRadioGroup.Item>
          <RadixLabel.Root
            className={styles.radioGroup__label}
            htmlFor={`radio-group-${index}`}
          >
            {entry.label}
          </RadixLabel.Root>
        </div>
      ))}
    </RadixRadioGroup.Root>
  );
});

RadioGroup.displayName = 'RadioGroup';

RadioGroup.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })),
  onChange: PropTypes.func,
  value: PropTypes.string
};

export default RadioGroup;
